import { useQuery } from "@tanstack/react-query";
import { getLivePulseSnapshot } from "@/lib/social.functions";
import { useLanguage } from "@/hooks/useLanguage";

export function FomoTicker({ compact = false }: { compact?: boolean }) {
  const { t } = useLanguage();
  const q = useQuery({
    queryKey: ["social", "pulse_snap"],
    queryFn: () => getLivePulseSnapshot(),
    refetchInterval: 15_000,
  });
  const fans = q.data?.active_fans ?? 0;
  const burst = q.data?.hype_burst ?? 0;

  return (
    <div className={`flex items-center gap-3 rounded-full border border-border bg-background/70 ${compact ? "px-3 py-1" : "px-4 py-2"} text-[11px] font-bold backdrop-blur`}>
      <span className="flex items-center gap-1">
        <span className="text-base">🔥</span>
        <span className="font-mono tabular-nums">{fans}</span>
        <span className="text-muted-foreground">{t("fomo_active")}</span>
      </span>
      {burst > 0 && (
        <span className="flex items-center gap-1 text-[oklch(0.78_0.2_60)]">
          <span>⚡</span>
          <span className="font-mono tabular-nums">{burst}</span>
          <span className="text-muted-foreground">{t("fomo_burst")}</span>
        </span>
      )}
    </div>
  );
}